import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AtelierDetailTourItem } from '../../model/atelier-detail-tour-item';
import { AbstractAtelierView } from '../abstract-atelier.view';

@Component({
  selector: 'app-atelier-sub-project-view',
  templateUrl: './atelier-sub-project-view.component.html',
  styleUrls: ['./atelier-sub-project-view.component.scss']
})
export class AtelierSubProjectViewComponent extends AbstractAtelierView {
  @Input()
  item: AtelierDetailTourItem;

  constructor(private router: Router) {
    super();
  }

  openSign(event: Event): void {
    event.stopPropagation();
    this.router.navigateByUrl(
      '/atelier-sign/' + this.item.subProject.project.firstProduct.signId
    );
  }
}
